"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AuInput = _interopRequireWildcard(require("../elements/AuInput"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _constants = require("../../constants");
var _context, _context2;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "multi_select_dropdown-module__container___efi26",
  "options": "multi_select_dropdown-module__options___eaR7W",
  "option_container": "multi_select_dropdown-module__option_container___adFvz",
  "caption": "multi_select_dropdown-module__caption___WJMKy",
  "subCaption": "multi_select_dropdown-module__subCaption___Xspsn",
  "toggle": "multi_select_dropdown-module__toggle___ZO5k0"
};
class MultiSelectDropDown extends _react.default.Component {
  static propTypes = {
    options: T.arrayOf(T.shape({
      caption: T.oneOfType([T.number, T.string]),
      subCaption: T.oneOfType([T.number, T.string]),
      value: T.oneOfType([T.string, T.number, T.bool]).isRequired
    })),
    selection: T.arrayOf(T.oneOfType([T.string, T.number, T.bool])),
    onChange: T.func,
    onInit: T.func,
    readOnly: T.bool,
    className: T.string,
    disabled: T.bool
  };
  static defaultProps = {
    options: [],
    selection: [],
    readOnly: true,
    onChange: _constants.NOOP,
    disabled: false
  };
  state = {
    showOptions: false
  };
  inputRef = /*#__PURE__*/_react.default.createRef();
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  toggleDropdown() {
    this.setState(prevState => ({
      showOptions: !prevState.showOptions
    }));
  }
  handleClickOutside = (0, _bind.default)(_context = this.handleClickOutside).call(_context, this);
  handleClickOutside(event) {
    if (this.inputRef?.current && !this.inputRef.current.contains(event.target)) {
      this.setState({
        showOptions: false
      });
    }
  }
  toggleOption = (0, _bind.default)(_context2 = this.toggleOption).call(_context2, this);
  toggleOption(value) {
    this.props.toggleOption(value);
  }
  render() {
    const {
      readOnly,
      placeholder,
      className,
      options,
      disabled,
      selection
    } = this.props;
    const {
      showOptions
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, className),
      ref: this.inputRef
    }, /*#__PURE__*/_react.default.createElement(_AuInput.default, {
      onClick: () => this.toggleDropdown(),
      placeholder: placeholder,
      readOnly: readOnly,
      onMouseDown: e => e.preventDefault(),
      disabled: disabled
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: styles.toggle
    }), showOptions && options.length !== 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: styles.options
    }, (0, _map.default)(options).call(options, (option, i) => /*#__PURE__*/_react.default.createElement("div", {
      className: styles.option_container,
      key: i
    }, /*#__PURE__*/_react.default.createElement(_AuInput.default, {
      type: _AuInput.INPUT_TYPE_CHECKBOX,
      caption: /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayString: option.caption === 0 ? '0' : option.caption,
        className: styles.caption
      }),
      subCaption: /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayString: option.subCaption,
        className: styles.subCaption
      }),
      onClick: () => this.toggleOption(option.val),
      checked: (0, _includes.default)(selection).call(selection, option.val)
    })))));
  }
}
exports.default = MultiSelectDropDown;